import { useId, useEffect, useLayoutEffect } from 'react';
import { useLayerContext } from '../contexts/layer';
import { createEvent } from '../utilities/createEvent';

export const useLayer = (props) => {
  const { onClose, ...rest } = props;

  // Manage layer storage

  const id = useId();
  const layerId = 'layer' + id;

  const { layers, setLayers } = useLayerContext();

  useLayoutEffect(() => {
    setLayers([...layers, layerId]);

    return () => {
      // Clears current layer
      setLayers([...layers.filter((id) => id !== layerId)]);
    };
  }, []);

  // Clears old layers

  useEffect(() => {
    return () => {
      layers.filter((layer) => {
        if (!document.getElementById(layer)) {
          setLayers([...layers.filter((id) => id !== layer)]);
        }
      });
    };
  }, [layers]);

  // Add styling to lock scrolling

  useEffect(() => {
    const scrollbar = innerWidth - document.documentElement.clientWidth + 'px';

    if (!document.body.hasAttribute('style')) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = scrollbar;
    }

    return () => {
      if (layers.length === 1) {
        document.body.removeAttribute('style');
      }
    };
  }, [layers.length]);

  const onKeyDownHandler = (e) => {
    if (layers[layers.length - 1] === layerId && e.key === 'Escape') {
      e.stopPropagation();
      createEvent(onClose);
    }
  };

  const kbd = {
    onKeyDown: onKeyDownHandler,
    onMouseDown: onClose,
  };

  const rct = {
    id: layerId,
  };

  return {
    ...kbd,
    ...rct,
    ...rest,
  };
};
